(function () {
    'use strict';

    angular.module('common').directive('videoPlayer', VideoPlayerDirective);

    VideoPlayerDirective.$inject = [];
    function VideoPlayerDirective() {
        let uniqueId = 0;
        let linker = function(scope) {
            scope.video_player_id = 'video-container-' + uniqueId++;
        };
        return {
            require: ['?ngModel'],
            restrict: 'E',
            replace: true,
            link: linker,
            scope: {
                video_link:    '=videoLink',
                video_title:   '=videoTitle',
                captions_link: '=captionsLink',
                poster_link:   '=posterLink'
            },
            templateUrl: '/angular_templates/common/video_player_directive.html',
            controller: VideoPlayerDirectiveController,
            controllerAs: 'vm',
            bindToController: true ,// all things defined in the scope object above will be attached to scope.vm instead of $scope.
        };

    }

    VideoPlayerDirectiveController.$inject = ['$timeout', '$scope'];
    function VideoPlayerDirectiveController($timeout, $scope) {
        let vm = this;

        /********************/

        initialize();

        /********************/

        function initialize() {
            $timeout(function() {
                jwplayer($scope.video_player_id).remove();
                jwplayer($scope.video_player_id).setup({
                    "playlist": [{
                        "file": vm.video_link,
                        "title": vm.video_title,
                        "image": vm.poster_link,
                        "tracks":
                            [{
                            "kind": "captions",
                            "file": vm.captions_link,
                            "label": "English"
                        }]
                    }]
                });
            });
        }

        $scope.$watch('vm.video_link', function() {
            initialize();
        });
        $scope.$watch('vm.captions_link', function() {
            initialize();
        });
    }
})();